import { formatArrayAsCommaSeparatedString } from '@/utils/format';
import { handleResponseV2, makeGet } from '@/redux/api/helpers';
import { ShippingAuctionPayload, ShippingAuctionResponse, ShippingAuctionsStatus } from './shippingAuctions.types';

type GetShippingAuctionsParams = {
    authToken: string;
    deployment: string;
    payload: ShippingAuctionPayload;
};

type GetShippingAuctionsQueryParams = Omit<ShippingAuctionPayload, 'filters' | 'status'> & {
    alerts?: string;
    houseId?: number;
    houseType?: string;
    shippingPartner?: string;
    shippingService?: string;
    upcoming: boolean;
};

export const getShippingAuctions = ({ authToken, deployment, payload }: GetShippingAuctionsParams) =>
    new Promise<ShippingAuctionResponse>((resolve, reject) => {
        const { filters, page, pageSize, status } = payload;
        let params: GetShippingAuctionsQueryParams = {
            page,
            pageSize,
            upcoming: status === ShippingAuctionsStatus.Upcoming,
        };
        if (filters.alerts.length) {
            params.alerts = formatArrayAsCommaSeparatedString(filters.alerts);
        }
        if (filters.houseId) {
            params.houseId = filters.houseId;
        }
        if (filters.shippingPartners.length) {
            params.shippingPartner = formatArrayAsCommaSeparatedString(filters.shippingPartners);
        }
        if (filters.shippingServices.length) {
            params.shippingService = formatArrayAsCommaSeparatedString(filters.shippingServices);
        }
        if (filters.houseTypes.length) {
            params.houseType = formatArrayAsCommaSeparatedString(filters.houseTypes);
        }

        const request = makeGet({
            apiPath: 'catalog/upcoming-auctions',
            authToken,
            deployment,
            path: '<SHIPPING-API>',
            queryParams: params,
        });
        request.end((err, response) =>
            handleResponseV2({
                err,
                reject,
                resolve,
                response,
            })
        );
    });
